// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"afe950a8","356":"b0ce7a2b","607":"89fac100","690":"e3252110","773":"d5179994","845":"89fac100","867":"034c71d2","988":"89fac100"}[chunkId] + ".chunk.js";
};